import style from "./style.scss";
import { toChildArray } from "preact";
import { mergeClasses } from "../helpers";

/**
 * @typedef {import("./button").ButtonProps} ButtonProps
 */

/**
 * @typedef {"medium" | "small" | null} ButtonSize
 *
 * @typedef {object} ButtonListProps
 * @property {ButtonSize} [size]
 * @property {import("preact").JSX.HTMLAttributes["class"]} [class]
 * @property {import("preact").VNode<ButtonProps> | import("preact").VNode<ButtonProps>[]} children
 *
 * @param {ButtonListProps} props
 */
const ButtonList = ({
  class: className = null,
  size = null,
  children,
  ...props
}) => {
  const mergedClass = mergeClasses([
    style.buttonList,
    size == "medium" ? style.medium : null,
    className,
  ]);
  const items = toChildArray(children);

  return (
    <ul class={mergedClass} {...props}>
      {items.map((child, i) => (
        <li key={i}>{child}</li>
      ))}
    </ul>
  );
};

export default ButtonList;
